import UserApis from './APIs/user-apis';
import chatApis from './APIs/chat-apis';
import dropdownApis from './APIs/dropdown-apis';
import propertyApis from './APIs/property-apis';
import agentApis from './APIs/agent-apis';
import unLockChatsAPIs from './APIs/unlockChat-apis';
import notificationAPIs from './APIs/notification-apis';
import organisationAPIs from './APIs/organisation-apis';
import analyticsApis from './APIs/analytics-apis';
import subscriptionApis from './APIs/subscription-apis';
import mapsApis from './APIs/maps-apis';

const apis = {
  user: UserApis,
  chat: chatApis,
  dropdown: dropdownApis,
  property: propertyApis,
  agent: agentApis,
  unlockchats: unLockChatsAPIs,
  notification: notificationAPIs,
  organisation: organisationAPIs,
  analytics: analyticsApis,
  subscription: subscriptionApis,
  maps: mapsApis
};

export default apis;
